module.exports = __webpack_public_path__ + "static/media/bankId.69d9b7ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/bankId.jpg
// module id = 1012
// module chunks = 0